"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionRepository = void 0;
const routerUtils_1 = require("../router/routerUtils");
const zustandStore_1 = require("../zustandStore");
const httpRepository_1 = __importDefault(require("./httpRepository"));
exports.SessionRepository = {
    async logout() {
        const { resetZustandStore } = zustandStore_1.useZustand.getState();
        resetZustandStore();
        (0, routerUtils_1.removePreLoginRouterState)();
        const response = await httpRepository_1.default.tradeshiftGo().post('/auth/logout', {});
        return response.data;
    },
    getStatus: async () => {
        const response = await httpRepository_1.default.tradeshiftGo().get('/auth/status');
        return response.data;
    },
    async login(data) {
        const response = await httpRepository_1.default.tradeshiftGo().post('/auth/login', data);
        return response.data;
    },
    getSaml(email) {
        return httpRepository_1.default.tradeshiftGo().get('/auth/saml?email=' + encodeURIComponent(email));
    },
    async register(data) {
        const response = await httpRepository_1.default.tradeshiftGo().post('/auth/register', data);
        return response.data;
    },
    async forgotPassword(data) {
        return httpRepository_1.default.tradeshiftGo().post('/auth/password/forgot', data);
    },
    async confirmToken(data) {
        if (!data) {
            throw new Error('userId or activationToken is invalid');
        }
        const response = await httpRepository_1.default.tradeshiftGo().get(`/auth/users/${data.userId}/token/${data.activationToken}`);
        return response.data;
    },
    async activateUser(options) {
        const response = await httpRepository_1.default.tradeshiftGo().post('/auth/activate', options);
        return response.data;
    },
    // on register page
    async sendMfaCode(options) {
        const response = await httpRepository_1.default.tradeshiftGo().post('/auth/mfa/register', options);
        return response.data;
    },
    // send POST request so back-end sends sms code
    async askForSmsCode() {
        const response = await httpRepository_1.default.tradeshiftGo().post('/auth/phone/send');
        return response.data;
    },
    // send SMS code on user registration
    async sendSmsCode(options) {
        const response = await httpRepository_1.default.tradeshiftGo().post('/auth/phone/verify', options);
        return response.data;
    },
    // on login page or on register new company
    async sendMfaCodeChallenge(options) {
        return httpRepository_1.default.tradeshiftGo().post('/auth/mfa/challenge', options);
    },
    async sendMfaCodeChallengeSkip() {
        return httpRepository_1.default.tradeshiftGo().post('/auth/mfa/skip', '');
    },
    async requestActivationWithTemporaryPasswordQuery(options) {
        return httpRepository_1.default.tradeshiftGo()
            .post('auth/activate/password/verify', options)
            .then(response => response.data);
    },
    async resetPassword(data) {
        return httpRepository_1.default.tradeshiftGo().post('/auth/password/reset', data);
    },
    async reset2FA(userId) {
        const response = await httpRepository_1.default.tradeshiftGo().post(`/rest/users/${userId}/mfa/reset`);
        return response.data;
    },
};
